module.exports = __webpack_public_path__ + "img/jujia.09da4423.png";